import React, {Component} from "react";
import TabsCard from "../../ui/cards/TabsCard";
import TransfersTab from "./full_profile/tabs/TransfersTab";
import HorizontalTabs from "../../ui/tabs/HorizontalTabs";
import UpcomingMatches from "./matches_and_events/UpcomingMatches";
import Results from "./matches_and_events/Results";

import '../../../assets/sass/pages/matches-and-events.scss';
import Events from "./matches_and_events/Events";

class MatchesAndEvents extends Component {
    render() {
        const items = [
            HorizontalTabs.createItem('Upcoming Matches', <UpcomingMatches/>),
            HorizontalTabs.createItem('Results', <Results/>),
            HorizontalTabs.createItem('Events', <Events/>),
        ];

        return (
            <TabsCard items={items}/>
        );
    }

}

export default MatchesAndEvents;
